import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M10 13a2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2 2 2 0 012 2z" opacity={0.35} /><path d="M8 2C5.186 2 2.828 3 1 4.586V6h1.48C4 4.736 5.7 4 8 4c2.3 0 4 .78 5.52 2H15V4.62C13.36 3.153 10.814 2 8 2z" style={{
        marker: "none"
      }} color="#000" overflow="visible" opacity={0.35} /><path d="M8 5c-2.167 0-4.02.739-5 2v1h2c.789-.606 1.759-1 3-1s2.22.394 3 1h2V7c-.995-1.223-2.873-2-5-2z" style={{
        marker: "none"
      }} color="#000" overflow="visible" opacity={0.35} /><path d="M8 8c-1.257 0-2.216.312-3 1v1h6V9c-.837-.672-1.743-1-3-1z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="Sans" overflow="visible" opacity={0.35} /></g></svg>;
}

export default SvgComponent;